import {
  BooleanDimension,
  ExclusionDimension,
  FinancialRateDimension,
  FinancialRateWithUnsetDimension,
  IntegerDimension,
  StringsEnumDimension,
  StringsWithDataEnumDimension,
  type TypeOfDimension,
} from '@orus.eu/dimensions'
import { esMrpaxeProductVersions } from '@orus.eu/product'

export const esMrpaxeClaimsInLastThreeYearsDimension = new IntegerDimension({
  name: 'esMrpaxeClaimsInLastThreeYears',
  displayKeys: {
    name: 'dimension_name_es_mrpaxe_claims_in_last_three_years',
    placeholder: 'dimension_placeholder_es_mrpaxe_claims_in_last_three_years',
    hint: 'dimension_hint_es_mrpaxe_claims_in_last_three_years',
  },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxeYearsInOperationDimension = new IntegerDimension({
  name: 'esMrpaxeYearsInOperation',
  displayKeys: { name: 'dimension_name_es_mrpaxe_years_in_operation' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxePremiseLocationDimension = new StringsWithDataEnumDimension({
  name: 'esMrpaxePremiseLocation',
  displayKeys: {
    name: 'dimension_name_es_mrpaxe_premise_location',
    hint: 'dimension_hint_es_mrpaxe_premise_location',
  },
  entries: [
    ['Urbano', { label: 'Urbano' }], // Urban area
    ['Centro Commercial', { label: 'Centro Comercial' }], // Shopping center
    ['Polígono', { label: 'Polígono' }], // Industrial park
  ] as const satisfies [string, { label: string }][],
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type EsMrpaxePremiseLocation = TypeOfDimension<typeof esMrpaxePremiseLocationDimension>

export const esMrpaxePremiseHasTerraceDimension = new BooleanDimension({
  name: 'esMrpaxePremiseHasTerrace',
  displayKeys: {
    name: 'dimension_name_es_mrpaxe_premise_has_terrace',
    hint: 'dimension_hint_es_mrpaxe_premise_has_terrace',
  },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxePremiseUnderConstructionDimension = new BooleanDimension({
  name: 'esMrpaxePremiseUnderConstruction',
  displayKeys: {
    name: 'dimension_name_es_mrpaxe_premise_under_construction',
    hint: 'dimension_hint_es_mrpaxe_premise_under_construction',
  },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxePremiseIsInShoppingCenterBiggerThan3000M2Dimension = new BooleanDimension({
  name: 'esMrpaxePremiseIsInShoppingCenterBiggerThan3000M2',
  displayKeys: {
    name: 'dimension_name_es_mrpaxe_premise_in_shopping_center',
  },
  considerForDifferenceComputationInUi: { client: true, partner: true, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxeFireProtectionLevelDimension = new StringsWithDataEnumDimension({
  name: 'esMrpaxeFireProtectionLevel',
  displayKeys: { name: 'dimension_name_es_mrpaxe_fire_protection_level' },
  entries: [
    ['Nivel 1', { label: 'Nivel 1' }], // Level 1
    ['Nivel 2', { label: 'Nivel 2' }], // Level 2
    ['Nivel 3', { label: 'Nivel 3' }], // Level 3
  ] as const satisfies [string, { label: string }][],
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type EsMrpaxeFireProtectionLevel = TypeOfDimension<typeof esMrpaxeFireProtectionLevelDimension>

export const esMrpaxeGeneralDeductibleDimension = new StringsWithDataEnumDimension({
  name: 'esMrpaxeGeneralDeductible',
  displayKeys: { name: 'dimension_name_es_mrpaxe_general_deductible' },
  entries: [
    ['0', { label: '0€' }],
    ['300', { label: '300€' }],
    ['600', { label: '600€' }],
  ] as const satisfies [string, { label: string }][],
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export type EsMrpaxeGeneralDeductible = TypeOfDimension<typeof esMrpaxeGeneralDeductibleDimension>

export const esMrpaxeDefaultManagementFeeRateDimension = new FinancialRateDimension({
  name: 'esMrpaxeDefaultManagementFeeRate',
  displayKeys: { name: 'dimension_name_es_mrpaxe_default_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const esMrpaxeManuallySetManagementFeeRateDimension = new FinancialRateWithUnsetDimension({
  name: 'esMrpaxeManuallySetManagementFeeRate',
  displayKeys: { name: 'dimension_name_es_mrpaxe_manually_set_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const esMrpaxeManagementFeeRateDimension = new FinancialRateDimension({
  name: 'esMrpaxeManagementFeeRate',
  displayKeys: { name: 'dimension_name_es_mrpaxe_management_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxeDefaultInstallmentFeeRateDimension = new FinancialRateDimension({
  name: 'esMrpaxeDefaultInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_es_mrpaxe_default_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const esMrpaxeManuallySetInstallmentFeeRateDimension = new FinancialRateWithUnsetDimension({
  name: 'esMrpaxeManuallySetInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_es_mrpaxe_manually_set_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const esMrpaxeInstallmentFeeRateDimension = new FinancialRateDimension({
  name: 'esMrpaxeInstallmentFeeRate',
  displayKeys: { name: 'dimension_name_es_mrpaxe_installment_fee_rate' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxeInputExclusionsDimension = new ExclusionDimension({
  name: 'esMrpaxeInputExclusions',
  displayKeys: { name: 'dimension_name_es_mrpaxe_input_exclusions' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
export const esMrpaxeExclusionsDimension = new ExclusionDimension({
  name: 'esMrpaxeExclusions',
  displayKeys: { name: 'dimension_name_es_mrpaxe_exclusions' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)

export const esMrpaxeProductVersionDimension = new StringsEnumDimension({
  name: 'esMrpaxeProductVersion',
  displayKeys: { name: 'dimension_name_es_mrpaxe_product_version' },
  values: esMrpaxeProductVersions,
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
